export default "__VITE_ASSET__BclLjFzE__"